import React, { Component } from 'react';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import WizardForm from '../../../../components/advertisers/campaigns/wizard/WizardForm';
import CardsFormModal from '../../../../components/advertisers/cards/CardsForm';

class Wizard extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      page: 1,
      hasCard: true
    };
  }

  componentDidMount() {
    this.setHasCard();
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.customer.id !== this.props.customer.id) ||
      (prevProps.customer.default_source !== this.props.customer.default_source)
    ) {
      this.setHasCard();
    }
  }


  setHasCard() {
    const { customer } = this.props;
    if (customer.default_source) {
      this.setState({ hasCard: true });
    } else {
      this.setState({ hasCard: false });
    }
  }

  handleAddCard() {
    const { dispatch, account } = this.props;
    dispatch(show('CardFormModal', {
      formAction: 'Add',
      title: 'Add Card',
      account
    }));
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
  }

  render() {
    const { account } = this.props;
    const { page, hasCard } = this.state;
    return (
      <div>
        <div className="row">
          <div className="col-lg-12 m-b-lg">
            <h2>Follow the steps below to create your campaign!</h2>
          </div>
        </div>
        <div className="row text-center">
          <ul className="circle-progress">
            <li className={(page > 1 && 'completed')}>Add Jobs</li>
            <li className={(page > 2 && 'completed')}>Select Jobs</li>
            <li
              className={`${page > 3 && 'completed'}
                ${page > 3 && !hasCard && 'warning'}`}
            >
              Create Campaign
            </li>
            <li>Check Status</li>

          </ul>
        </div>
        <br />
        <br />

        <WizardForm
          page={page}
          next={this.nextPage}
          prev={this.previousPage}
          account={account}
          hasCard={hasCard}
          handleAddCard={this.handleAddCard.bind(this)}
        />

        <CardsFormModal />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { params: { accountSlug } } = ownProps;
  const { advertiser: { accounts, customers } } = state;

  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};

  const customer = (customers.data.data || [])
    .filter((w) => w.advertiser_account_uuid === account.uuid)[0] || {};

  return { account, customer };
};

export default connect(mapStateToProps)(Wizard);
